export class AppConsts {  
    static apiBaseUrl: string;
    static fileUploadUrl: string;
    static fileDownloadUrl: string;
    static uploadProfilePicUrl: string;

    static mobileBaseUrl = 'https://inv-mashwara-api.azurewebsites.net';
    // static mobileBaseUrl = 'https://webui-co2.conveyor.cloud';
}  
